import AlarmGroupsRoutes from './AlarmGroupsRoutes';

export function AlarmGroupsRoot() {
  return <AlarmGroupsRoutes />;
}

export default AlarmGroupsRoot;
